import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const REGISTERTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('code', 'Entity.RegisterType.Code')
    .required()
    .maxLength(10)
    .build(),
  FieldBuilder
    .text('name', 'Entity.RegisterType.Name')
    .required()
    .maxLength(100)
    .build(),
];

export const REGISTERTYPE_CONFIG = {
  entityName: 'RegisterType',
  localizationKey: 'Planning::Entity.RegisterType',
  fields: REGISTERTYPE_FIELDS,
  permission: 'Planning.RegisterTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Environment + MENU_NAME_SUFFIX,
};
